<header id="header" class="">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4 col-xs-4 text-left">
        <div data-toggle="modal" data-target="#menuModal" class="custom-btn">
          <i class="icon-wb stroke R3"></i>menu
        </div>
      </div>
      <div class="col-md-4 col-xs-4 text-center desktop-show logo-container">
        <a href="/#/home" title="WellBrain">
          <img src="/assets/images/WellBrain.png" alt="WellBrain logo">
        </a>
      </div>
    </div>
  </div>
</header>
<main id="content">
  <section class="paths">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <nav id="paths-nav">
            <ul class="flex-row">
              <li>
                <a href="/#/my-paths" class="custom-btn btn-block" [ngClass]="{'state-active': myPathsTab}">My paths</a>
              </li>
              <li>
                <a href="/#/explore-paths" class="custom-btn btn-block" [ngClass]="{'state-active': !myPathsTab}">Explore Paths</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="row" *ngIf="explorePathsObj.length > 0" [ngClass]="{'hideRow': myPathsTab}">
        <ul class="col-md-12 paths-list">
          <div class="path" *ngFor="let explorePath of explorePathsObj">
            <div class="row">
              <div class="col-md-4 path-image">
                <img src={{explorePath.image}} alt="path-image">
              </div>
              <div class="col-md-8 path-details">
                <div class="row">
                  <div class="col-md-12 description">
                    <a href="/#/paths/{{explorePath.id}} " class="link heading-sm">{{explorePath.name}}</a>
                    <p class="text text-md">{{explorePath.short_description}}
                    </p>
                    <a href="/#/paths/{{explorePath.id}} " class="link block text-uppercase">Show path details
                      <i class="icon-wb stroke W20"></i>
                    </a>
                  </div>
                  <div class="col-md-12 p-bottom full-width desktop-show">
                    <div class="row">
                      <div class="col-md-4">
                      </div>
                      <div class="col-md-8 text-right">
                        <div class="group">
                          <p class="text text-sm">{{explorePath.users_completed}} patients have completed this</p>
                          <p class="text text-sm">{{explorePath.users_active}} currently assigned patients</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </div>
      <div class="row" *ngIf="myPathsObj.length > 0" [ngClass]="{'hideRow': !myPathsTab}">
        <ul class="col-md-12 paths-list">
          <div class="path" *ngFor="let path of myPathsObj">
            <div class="row">
              <div class="col-md-4 path-image">
                <img src={{path.image}} alt="path-image">
              </div>
              <div class="col-md-8 path-details">
                <div class="row">
                  <div class="col-md-12 description">
                    <a href="/#/paths/{{path.id}}" class="link heading-sm">{{path.name}}</a>
                    <p class="text text-md">{{path.short_description}}
                    </p>
                    <a href="/#/paths/{{path.id}}" class="link block text-uppercase">Show path details
                      <i class="icon-wb stroke W20"></i>
                    </a>
                  </div>
                  <div class="col-md-12 p-bottom full-width desktop-show">
                    <div class="row">
                      <div class="col-md-4">
                      </div>
                      <div class="col-md-8 text-right">
                        <div class="group">
                          <p class="text text-sm">{{path.users_completed}} patients have completed this</p>
                          <p class="text text-sm">{{path.users_active}} currently assigned patients</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </div>
  </section>
</main>
<app-dailyquotes></app-dailyquotes>
<app-footer></app-footer>
<app-menu></app-menu>


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/mypaths/mypaths.component.html